// extracted by mini-css-extract-plugin
export default {"StaticDiffPreview":"StaticUnifiedDiffPreview-module__StaticDiffPreview--LEJAb","HeaderContainer":"StaticUnifiedDiffPreview-module__HeaderContainer--uY_eJ"};